import { Link } from "react-router-dom";
import forkdLogo from "@/assets/forkd-logo.png";

export default function Landing() {
  return (
    <main
      className="min-h-[100dvh] w-full flex flex-col items-center justify-between px-6 py-10"
      style={{ background: "#0A2540" }}
    >
      <div className="flex-1 w-full flex flex-col items-center justify-center text-center max-w-sm mx-auto">
        <div className="rounded-full overflow-hidden mb-6">
          <img
            src={forkdLogo}
            alt="Forkd"
            className="w-40 h-40 sm:w-48 sm:h-48 select-none"
            draggable={false}
          />
        </div>
        <p
          className="mb-10"
          style={{
            fontFamily: "'Outfit', sans-serif",
            fontWeight: 900,
            fontSize: "28px",
            color: "#F97316",
            letterSpacing: "0.08em",
            textShadow: "0 2px 12px rgba(249,115,22,0.4)",
            textTransform: "uppercase",
          }}
        >
          LET'S FORK THINGS UP.
        </p>

        <ul className="space-y-4 text-left w-full mb-10">
          <li className="flex items-start gap-3 text-white/90 text-base leading-snug">
            <span className="text-2xl leading-none">🍜</span>
            <span>Collect cuisines, dishes, and restaurants</span>
          </li>
          <li className="flex items-start gap-3 text-white/90 text-base leading-snug">
            <span className="text-2xl leading-none">🏆</span>
            <span>Earn badges. Beat your friends.</span>
          </li>
          <li className="flex items-start gap-3 text-white/90 text-base leading-snug">
            <span className="text-2xl leading-none">📍</span>
            <span>Discover your city one meal at a time</span>
          </li>
        </ul>
      </div>

      <div className="w-full max-w-sm mx-auto flex flex-col items-center gap-4 pb-2">
        <Link
          to="/signup"
          className="w-full text-center rounded-full py-4 text-lg font-semibold text-[var(--colour-on-accent,#0A2540)] shadow-lg active:scale-[0.98] transition"
          style={{ background: "var(--colour-accent)" }}
        >
          Get Started
        </Link>
        <Link
          to="/signin"
          className="text-white/70 hover:text-white text-sm underline-offset-4 hover:underline"
        >
          Sign In
        </Link>
      </div>
    </main>
  );
}
